import { Icon } from "web/components"
import classNames from "classnames"

export default function InfoMessage({ title, children, className }) {
  return (
    <div className={classNames("rounded-md bg-yellow-50 p-4", className)}>
      <div className="flex">
        <div className="mr-3 h-5 w-5 shrink-0 text-yellow-400">
          <Icon name="exclamation-triangle" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">{title}</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>{children}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
